import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";

document.addEventListener("DOMContentLoaded", (event) => {
  window.addEventListener("load", (e) => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(TextPlugin);

    gsap.to(".has-text-animation", {
      delay: 2,
      duration: 3,
      text: "We take care of everything – from design to content management, so you can focus on what you do best.",
      ease: "none",
    });

    gsap.utils.toArray(".has-animation").forEach((section) => {
      const childElements = Array.from(section.children);

      childElements.forEach((element, index) => {
        // Decide the direction based on the index
        const [x, xEnd] = index % 2 === 0
            ? [element.scrollWidth * -1, 0]   // For even indexed elements: start from left out of view and scroll to normal position
            : [element.scrollWidth, 0];      // For odd indexed elements: start from right out of view and scroll to normal position

        gsap.fromTo(element, { x }, {
          x: xEnd,
          scrollTrigger: {
            trigger: section,
            start: "top bottom", // starts the animation when the top of the element hits the bottom of the viewport
            end: "bottom 90%",   // ends the animation when the bottom of the element is 90% from the top of the viewport
            scrub: 0.5,
            once: true
          }
        });
      });
    });
  }, false);
});
